import React, { Component } from 'react';
import axios from 'axios';
import Header from "./Header";
import Wizard from "./Wizard";
import Saloncode from './Saloncode';
import Salons from './Salons';
import Result from "./Result";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
        result: null,
        isLoading: false,
        page: "saloncode",
        saloncode: null,
        nSaloncode: false,
        salon: null,
        setup: {},
        getdata: {},
        images: null,
        dates: null,
        times: null,
        data: {
          sex: null,
          stylist: {
            id: 0,
            naam: "Geen voorkeur"
          },
          date: null,
          time: null,
          treatments: [],
          ack: {
            Achternaam: "",
            Voorletters: "",
            Voornaam: "",
            Adres: "",
            Postcode: "",
            Woonplaats: "",
            Telefoon: "",
            Email: "",
            Opmerking: "",
        },
        }
    }
  }

  componentDidMount = () => {
    
  }

  getSetup = () => {
    this.setLoading(true);
    axios.post('https://app.maakafspraak.eu/app?', {
      "action": "setup",
      "taal":"nl",
      "salonCode": this.state.saloncode,
      "salon":0
    })
    .then((response) => {
        if (response.data["salons"].length === 0) {
            this.setState((prevState) => {
              prevState.nSaloncode = true;
              return prevState;
            }, () => this.setLoading(false));
        } else {
          this.setState((prevState) => {
            prevState.nSaloncode = false;
            prevState.setup = response.data;
            return prevState;
          }, () => {
            this.setLoading(false);
            this.setPage("salons");
          });
        }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  getData = () => {
    axios.post('https://app.maakafspraak.eu/app?', {
      "action": "getdata",
      "taal":"nl", 
      "salon":99999,
    })
    .then((response) => {
      this.setState((prevState) => {
        prevState.getdata = response.data;
        return prevState;
      }, () => {
        this.getImages();
        this.setPage("wizard");
      });
    })
    .catch((error) => {
      console.log(error);
    });
  }

  getImages = () => {
    let images = {};
    this.state.getdata["stylisten"].forEach((item) => {
      if (item["imagename"]) {
        axios.post('https://app.maakafspraak.eu/app', {
          "action": "getimage",
          "taal":"nl", 
          "ImageId":item["imagename"],
          "salon": 99999
        })
        .then((response) => {
          images["id_" + item["id"]] = response.data["imagedata"];
        })
        .catch((error) => {
          console.log(error);
        });
      } 
    });
    this.setState((prevState) => {
      prevState.images = images;
      return prevState;
    });

  }

  getDates = () => {
    
    axios.post('https://app.maakafspraak.eu/app',{
      "action": "getdates", 
      "taal":"nl",  
      "stylist": this.state.data.stylist["id"], 
      "salon": this.state.salon,
      "behandelingen": this.state.data.treatments
    })
    .then((response) => {
      this.setState((prevState) => {
        prevState.dates = response.data["datums"];
        return prevState;
      });
    })
    .catch((error) => {
      console.log(error);
    });
  }

  resetDates = () => {
    this.setState((prevState) => {
      prevState.dates = null;
      return prevState;
    })
  }

  getTimes = () => {
    axios.post('https://app.maakafspraak.eu/app', {
      "action": "gettimes",
      "taal":"nl", 
      "date":this.state.data.date,
      "salon": this.state.salon,
      "stylist": this.state.data.stylist["id"],
      "wilalleen": false,
      "behandelingen": this.state.data.treatments,
    })
    .then((response) => {
      this.setState((prevState) => {
        prevState.times = response.data["stylisten"];
        return prevState;
      }); 
    })
    .catch((error) => {
      console.log(error);
    });
  }

  resetTimes = () => {
    this.setState((prevState) => {
      prevState.times = null;
      return prevState;
    });
  }

  getSexCode = (name) => {
    let code;
    this.state.getdata["geslacht"].forEach((sex) => {
      if (sex["naam"] === name)
      code = sex["code"];
    });
    return code;
  }

  finish = () => {
    axios.post('https://app.maakafspraak.eu/app', {
      "action": "writedata",
      "taal": "nl",
      "date":this.state.data.date,
      "salon": this.state.salon,
      "time": {
        "stylistid": this.state.data.stylist["id"],
        "time": this.state.data.time,
      },
      "stylist": this.state.data.stylist["id"],
      "behandelingen": this.state.data.treatments,
      "geslacht": this.getSexCode(this.state.data.sex),
      "naw": this.state.data.ack}
    )
    .then((response) => {
      this.setState((prevState) => {
        prevState.result = response.data["resultaat"];
        return prevState;
      }); 
    })
    .catch((error) => {
      console.log(error);
    });
  }

  setSaloncode = (code) => {
    this.setState((prevState) => {
      prevState.saloncode = code;
      return prevState;
    }, () => {
      this.getSetup();
    });
  }

  setSalon = (code) => {
    this.setState((prevState) => {
      prevState.salon = code;
      return prevState;
    }, () => {
      this.getData();
    });
  }

  setPage = (page) => {
    this.setState((prevState) => {
      prevState.page = page;
      return prevState;
    })
  }

  setSex = (sex) => {
    this.setState((prevState) => {
        prevState.data.sex = sex;
        return prevState; 
    });
  }

  setTreatments = (treatments) => {
    this.setState((prevState) => {
      prevState.data.treatments = treatments;
      return prevState;
    });
    this.resetDates();
    this.setDate(null);
  }

  setStylist = (stylist) => {
    this.setState((prevState) => {
      prevState.data.stylist = stylist;
      return prevState;
    });
  }

  setDate = (date) => {
    this.setState((prevState) => {
      prevState.data.date = date;
      return prevState;
    });
    this.resetTimes();
  }

  setTime = (time) => {
    this.setState((prevState) => {
      prevState.data.time = time;
      return prevState;
    });
  }

  setAck = (ack) => {
    this.setState((prevState) => {
      prevState.data.ack = ack;
      return prevState;
    });
  }

  setLoading = (val) => {
    this.setState((prevState) => {
      prevState.isLoading = val;
      return prevState;
    });
  }

  route = () => {
    let page;
    switch(this.state.page) {
        case "saloncode":
          page = <Saloncode nSaloncode={this.state.nSaloncode} 
                      setSaloncode={this.setSaloncode}
                      isLoading={this.state.isLoading} 
                  />
          break;
        case "salons":
          page = <Salons setSalon={this.setSalon} setup={this.state.setup} />
          break; 
        case "wizard":
          page = <Wizard
                      finish={this.finish} 
                      setup={this.state.setup} 
                      getdata={this.state.getdata} 
                      images={this.state.images}
                      dates={this.state.dates}
                      getDates={this.getDates}
                      times={this.state.times}
                      getTimes={this.getTimes} 
                      data={this.state.data}
                      setSex={this.setSex}
                      setTreatments={this.setTreatments}
                      setStylist={this.setStylist}
                      setDate={this.setDate}
                      setTime={this.setTime}
                      setAck={this.setAck}
                      isloading={this.state.isLoading}
                      setPage={this.setPage}
                    />
          break;
        case "result":
          page = <Result result={this.state.result}/>;
          break;
        default:
    }
    return page;
  }

  render() {
    return (
      <React.Fragment>
        <style dangerouslySetInnerHTML={{__html: `
        `}} />  
      <Header setPage={this.setPage}/>
        {this.route()}
      </React.Fragment>
    );
  }
}

export default App;